import { render } from "./SaquesPage.vue?vue&type=template&id=02a0d983&scoped=true"
import script from "./SaquesPage.vue?vue&type=script&lang=js"
export * from "./SaquesPage.vue?vue&type=script&lang=js"

import "./SaquesPage.vue?vue&type=style&index=0&id=02a0d983&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a0d983"]])

export default __exports__